<template>
  <div class="sucPage">
    <div class="sbarBox">
      <img src="https://pohto-imgs.oss-cn-beijing.aliyuncs.com/uploads/2025/1106/320025FB40AC5888.jpg" alt="" />
    </div>
    <div class="allCon">
      <step :active="2"></step>
      <div class="tsBox">
        <div class="topTxt" v-html="gconfig.SuccessPage"></div>
        <div class="successCon">
          <h3>{{ visitorObj.VisitorName }}</h3>
          <p v-if="visitorObj.VistorRank">（{{ visitorObj.VistorRank }}）</p>
          <p v-if="visitorObj.VisitorComName" class="conname">
            {{ visitorObj.VisitorComName }}
          </p>
          <div class="qrMain">
            <div class="qrbox">
              <qrcode-vue
                :value="visitorObj.VistorVisCard"
                :size="100"
              ></qrcode-vue>
            </div>
          </div>
        </div>
      </div>
      <!-- 会议列表 -->
      <div class="meetingS">
        <div class="opera">
          <div
            v-for="item in ops"
            :key="item.val"
            :class="{ operaItem: true, active: currentOp === item.val }"
            @click="changeOp(item.val)"
          >
            <div style="display: flex; align-items: center; padding-left: 7px">
              <img :src="item.img" style="width: 20px; height: 20px" alt="" />
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
        
        <ul class="meetBox" v-if="currentOp === 'tq'">
          <h3>
          To register for the concurrent conference, please click on the links below.
        </h3>
          <li v-for="item in meetList" :key="item.name">
            <div class="itemWrap">
              <div class="itemCon">
                <h4>{{ item.name }}</h4>
                <div>
                  <span>
                    <van-icon class="hisIcon" name="clock-o" />
                    {{ item.date }}
                  </span>
                  <van-button
                    class="meetBtn"
                    round
                    :color="meetBtnColor"
                    type="primary"
                    size="mini"
                    native-type="submit"
                    :disabled="btnLoading"
                    :loading="btnLoading"
                    @click="toMeet(item.link)"
                  >
                    Click to register
                  </van-button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="meetBox" v-if="currentOp === 'xz'">
          <li class="addBtnBox">
            <div class="button-group">
              <van-button
                :color="mainColor"
                size="normal"
                round
                class="custom-btn add-btn wider-btn"
                @click="toadd">
                <van-icon name="plus" class="btn-icon" />Add
              </van-button>
            </div>
          </li>

          <li v-for="item in invisList" :key="item.visitorID">
            <div class="itemWrap">
              <div class="itemCon">
                <h4>{{ item.visitorName }}</h4>
                <div>
                  <h5>{{ item.visitorComName }}</h5>
                  <!--   <van-button
                    class="meetBtn"
                    round
                    :color="meetBtnColor"
                    type="primary"
                    size="mini"
                    native-type="submit"
                    :disabled="btnLoading"
                    :loading="btnLoading"
                  >
                    短信通知
                  </van-button> -->
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div v-html="gconfig.SuccessPageBottomText"></div>
  <div class="shMask" v-show="showSh">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div class="shConBox">
      <div class="shDiv">
        <img :src="shIcon" alt="" />
        <h3>Under review</h3>
        <div v-html="shContent" class="shTxt"></div>
      </div>
    </div>
  </div>
  <!-- 身份证 -->
  <div class="shMask" v-show="showVerCard">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div>
      <p style="padding: 15vw 0 8vw; font-size: 1.2em; font-weight: 600">
        请您补充证件号码，完成实名认证！
      </p>
      <van-form @failed="onFailed" @submit="onSubmit">
        <van-cell-group>
          <!-- 姓名 -->
          <van-field
            v-model="formMg.Name"
            Name="Name"
            label="姓名"
            :rules="rulesAll.Name"
            class="requiredItem"
          />
          <!-- 身份证号 -->
          <van-field
            class="requiredItem"
            v-model="formMg.IDCardNo"
            Name="IDCardNo"
            label="身份证号"
            :rules="rulesAll.IDCardNo"
          />
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            round
            style="width: 45%"
            :color="mainColor"
            type="primary"
            native-type="submit"
            :disabled="btnLoading"
            :loading="btnLoading"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script setup>
import shIcon from '@/assets/shIcon.png'
import sbar from '@/assets/vis/sbar.png'
import { ref, computed, onMounted } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import step from '@/components/step.vue'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import { validatorName } from '@/utils/validators.js'
import { regCId } from '@/utils/regs.js'
import { useRouter, useRoute } from 'vue-router'
const store = useStore()
const router = useRouter()
const route = useRoute()
const ExhCode = computed(() => store.state.ExhCode)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalEValue
    })
  }
  return configObj
}
const mainColor = computed(() => store.state.mainColor)
console.log(gconfig.value, '222222222')
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
const ops = [
  // eslint-disable-next-line quotes
  { label: 'concurrent conference', val: 'tq', img: require('@/assets/2.png') },
  { label: 'Assist with registration', val: 'xz', img: require('@/assets/1.png') }
]
// 获取邀请列表
const invisList = ref([])
const getVis = async () => {
  const res = await api.GetVisitorListApi({
    exhcode: ExhCode.value,
    VisitorID: VisitorID.value
  })
  invisList.value = res.data
}
const currentOp = ref('tq')

const changeOp = (type) => {
  currentOp.value = type
  if (type === 'xz') {
    getVis()
  }
}
const meetList = ref([
  {
    name: '2025 Economic Situation and Power Development Analysis and Forecast Conference',
    date: 'March 26 (CNCC Phase Ⅱ)',
    link: 'https://reg.alljoy.com.cn/MicroWebsite/25ceec/#/indexA1?aid=6DMDH&pageType=A1'
  },
  {
    name: 'The 3rd China New Energy Overseas Investment Summit',
    date: 'March 26 (CNCC Phase Ⅱ)',
    link: 'https://reg.alljoy.com.cn/MicroWebsite/25ceec/#/indexA2?aid=91N1M-6&pageType=A2'
  },
  {
    name: 'Photovoltaic Innovation and Application Market Development Forum',
    date: 'March 26(CNCC Phase Ⅱ)',
    link: 'https://reg.alljoy.com.cn/MicroWebsite/25ceec/#/indexA3?aid=96M-1MD&pageType=A3'
  },
  {
    name: 'The 3rd China Energy Storage Conference ',
    date: 'March 27(CNCC Phase Ⅱ)',
    link: 'https://reg.alljoy.com.cn/MicroWebsite/25ceec/#/indexA4?aid=91363N3&pageType=A4'
   },
  {
    name: 'China International Hydrogen Congress 2025',
    date: 'March 26-27(CNCC Phase Ⅰ.Ⅱ)',
    link: 'https://xb29949609.m.jzfkw.net'
  }
])
const meetBtnColor = ref('linear-gradient(90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)')
const visitorObj = ref({})
// 是否显示审核
const showSh = ref(false)
// 审核显示内容
const shContent = ref('')

const toMeet = (linkurl) => {
  window.location.href = linkurl
}
const getMsg = async () => {
  const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  visitorObj.value = jmRes
  // console.log(visitorObj.value)
  // 判断是否显示审核
  if (gconfig.value.IsNeedCheck === 'True') {
    if (
      visitorObj.value.VisitorCheckSysstate === null ||
      visitorObj.value.VisitorCheckSysstate === '' ||
      visitorObj.value.VisitorCheckSysstate === '审核未通过'
    ) {
      showSh.value = true
      if (
        visitorObj.value.VisitorCheckSysstate === null ||
        visitorObj.value.VisitorCheckSysstate === ''
      ) {
        shContent.value = gconfig.value.WaitCheckContent
      } else {
        shContent.value = gconfig.value.CheckFailContent
      }
      return false
    } else {
      showSh.value = false
    }
  }
  if (gconfig.value.IsNeedIDCard === 'True') {
    // 是否需要补实名
    if (!visitorObj.value.VisitorIDCard) {
      // 如果没有身份证
      showVerCard.value = true
      formMg.value.Name = visitorObj.value.VisitorName
      return false
    }
    showVerCard.value = false
  }
  showSh.value = false
}
onMounted(() => {
  getMsg()
  if (isWeX.value) {
    wx.getWXSign()
  }
})
const showVerCard = ref(false)
const formMg = ref({
  Name: '',
  IDCardNo: ''
})
// 校验证件号
const validatorIDCardNo = (val) => {
  return regCId(val)
}
const rulesAll = ref({
  Name: [
    { required: true, validator: validatorName, message: '请输入正确的姓名' }
  ],
  IDCardNo: [{ validator: validatorIDCardNo, message: '请输入正确的身份证号' }]
})
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
const onSubmit = async (values) => {
  const res = await api.UpdateIDcardApi({
    VisitorID: VisitorID.value,
    Name: formMg.value.Name,
    IDCardNo: formMg.value.IDCardNo,
    exhcode: ExhCode.value
  })
  if (res.code === 200) {
    getMsg()
  }
}
const toadd = () => {
  router.push({ path: '/msgH' })
}
</script>
<style lang="less">
@import '../../assets/login.less';
.sucPage {
  .sbarBox {
    img {
      width: 100%;
    }
  }
  .allCon {
    border-radius: 30px 30px 0 0;
    border-radius: 8vw;
    overflow: hidden;
    margin-top: -8vw;
    background: #f6f6f6;
    position: relative;
    padding: 8vw 7vw;
    .stepBox {
      width: 100%;
    }
    .tsBox {
      background: #fff;
      border-radius: 20px;
      padding: 5vw 3vw;
      box-shadow: 0px 0px 5px #cecece;
      margin-top: 10px;
    }
  }
}

.meetingS {
  margin: 20px auto;
  .opera {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    .operaItem {
      padding: 1px;
      border-radius: 12px;
      width: 49%;
      > div {
        background: #fff;
        border-radius: 10px;
        padding: 12px 0;
        span {
          color: #000000;
          font-weight: bold;
        }
      }
    }
    .operaItem.active {
      background: linear-gradient(to right, #02599f, #a1c98b);
    }
  }
  h3 {
    color: #191919;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    border-bottom: 1px solid;
    border-image-source: linear-gradient(to right, #02599f, #a1c98b);
    border-image-slice: 1;

    padding-bottom: 2vw;
    margin-bottom: 5vw;
  }

  .meetBox {
    li {
      background: linear-gradient(180deg, #02599f, #a1c98b);
      padding: 1px;
      border-radius: 12px;
      margin-bottom: 3vw;
      .itemWrap {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0px 0px 10px #ececec;
        padding: 5vw 3vw;
        text-align: left;
        display: flex;
        align-items: center;
        background: #fff;
        &::before {
          content: ' ';
          display: inline-block;
          width: 1vw;
          height: 10vw;
          background: linear-gradient(180deg, #02599f, #a1c98b);
          border-radius: 0.5vw;
          margin-right: 2vw;
        }
        h4 {
          color: #4d4d4d;
          font-size: 12px;
          font-weight: 600;
          padding-bottom: 4px;
        }
        .itemCon {
          width: 100%;

          > div {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            > span {
              color: #191919;
              font-size: 13px;
              .hisIcon {
                margin-right: 3px;
              }
            }
          }
        }
      }
    }
    .addBtnBox {
      background: transparent;
      text-align: right;
      padding: 0;
      .button-group {
        display: flex;
        justify-content: flex-end;
      }
      .wider-btn {
        min-width: 150px;
        padding: 0 20px;
      }
      .addMemBtn {
        padding-bottom: 10px;
      }
    }
  }
  .meetBtn {
    color: #fff !important;
    padding: 0 8px;
  }
}
.shConBox {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9f9f9;
  .shDiv {
    position: absolute;
    top: 35%;
    left: 50%;
    margin-top: -50%;
    margin-left: -40%;
    width: 80%;
    background: #fff;
    box-shadow: 0px 0px 10px #eee;
    border-radius: 10px;
    padding: 8vh 0 15vh;
    h3 {
      text-align: center;
      color: #18bae5;
      font-size: 16px;
      padding: 2vh 0;
    }
    img {
      width: 30%;
    }
    .shTxt {
      text-align: left !important;
      font-size: 14px;
      line-height: 28px;
      color: #000;
      padding: 0 5vw;
    }
  }
}
.topTxt {
  padding: 0 10px;
  p {
    padding: 6px 0;
    color: #323233;
    font-size: 14px;
  }
}
.iconbox {
  text-align: center;
  padding-top: 5vh;
  img {
    width: 42vw;
  }
}
.btnbox {
  text-align: center;
  padding: 2vh 0 0 0;
}
.tipsTxt {
  color: #2090be;
  font-weight: bold;
  padding-top: 20px;
}
.qrMain {
  display: flex;
  justify-content: center;
  //padding-top: 20px;
  .qrbox {
    display: inline-block;
    // padding: 32px;
    border-radius: 12px;
    // box-shadow: 0px 0px 10px #ccc;
    padding: 3vw;
    background: linear-gradient(180deg, #02599f, #a1c98b);
    canvas {
      padding: 1.5vw;
      border-radius: 8px;
      background: #fff;
      display: block;
    }
  }
}
.successCon {
  //padding: 20px 0 30px;
  background: #fff;
  width: 90%;
  margin: 10px auto;
  border-radius: 6px;
  p,
  h3 {
    padding: 4px 0;
  }
  h3 {
    font-size: 18px;
  }
  .conname {
    font-size: 14px;
  }
}
.shMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 2;
}
@media screen and (min-width: 768px) {
  .sucPage {
    .sbarBox {
      margin-top: -160px;
    }
    .allCon {
      border-radius: 20px;
      padding: 20px 100px;
      margin-top: -3vw;
      .tsBox {
        padding: 1vw 3vw;
      }
    }
  }
  .qrMain {
    .qrbox {
      padding: 10px;
      canvas {
        padding: 8px;
      }
    }
  }
  .meetingS {
    h3 {
      padding-bottom: 10px;
      margin-bottom: 20px;
    }
    .meetBox {
      li {
        margin-bottom: 20px;
        .itemWrap {
          padding: 25px 12px;
          &::before {
            width: 6px;
            height: 50px;
          }
        }
      }
    }
  }
}
</style>
